import { MeetingPlanningAction, MeetingPlanningActionTypes } from "./MeetingPlanningActions"
import { IDelivery, IInitialDeliveryFormValues } from "../../../Types/MeetingPlanning/deliveryForm"
import { Reducer } from "redux"
import { DEFAULT_INITIAL_DELIVERY_FORM } from "../../../Static/MeetingPlanning/deliveryForm"

export interface IMeetingPlanningState {
    initialDeliveryForm: IInitialDeliveryFormValues
    meetingPlaningDeliveries: IDelivery[]
}

const initialState: IMeetingPlanningState = {
    initialDeliveryForm: DEFAULT_INITIAL_DELIVERY_FORM,
    meetingPlaningDeliveries: [],
}

const meetingPlanningReducer: Reducer<IMeetingPlanningState> = (
    state: IMeetingPlanningState = initialState,
    action: MeetingPlanningAction
): IMeetingPlanningState => {
    switch (action.type) {
        case MeetingPlanningActionTypes.CHANGE_INITIAL_DELIVERY_FORM:
            return { ...state, initialDeliveryForm: action.payload }

        case MeetingPlanningActionTypes.CHANGE_DELIVERY_DATA: {
            const {
                meetingName,
                fromDate,
                toDate,
                isCompleted,
                deliveryType,
                deliveryLocation,
                hasOtherDeliveryLocation,
                otherDeliveryLocation,
                deliveryTime,
                seats,
                extraServices,
                price,
            } = action.payload.formFields

            const meetingPlaningFormFields = {
                isCompleted,
                deliveryTime,
                extraServices,
                price,
            }

            const meetingPlaningData = {
                id: action.payload.id,
                isInitial: action.payload.isInitial,
                order: action.payload.order,
                formFields: meetingPlaningFormFields,
            }

            return {
                ...state,
                initialDeliveryForm: {
                    meetingName,
                    fromDate,
                    toDate,
                    deliveryType,
                    deliveryLocation,
                    hasOtherDeliveryLocation,
                    otherDeliveryLocation,
                    seats,
                },
                meetingPlaningDeliveries: state.meetingPlaningDeliveries.some(delivery => delivery.id === action.payload.id)
                    ? state.meetingPlaningDeliveries.map(delivery =>
                        delivery.id === action.payload.id
                            ? { ...delivery, ...meetingPlaningData }
                            : delivery
                    )
                    : [...state.meetingPlaningDeliveries, meetingPlaningData]
            }
        }

        case MeetingPlanningActionTypes.CHANGE_DELIVERIES_LIST:
            return {
                ...state,
                meetingPlaningDeliveries: action.payload
            }

        case MeetingPlanningActionTypes.ADD_DELIVERY_ORDER: {
            const { deliveryId, order } = action.payload;
            return {
                ...state,
                meetingPlaningDeliveries: state.meetingPlaningDeliveries.map(delivery =>
                    delivery.id === deliveryId
                        ? { ...delivery, order }
                        : delivery
                )
            };
        }

        case MeetingPlanningActionTypes.RESET_MEETING_DATA:
            return { ...initialState }

        case MeetingPlanningActionTypes.DELETE_DELIVERY:
            return { ...state, meetingPlaningDeliveries: state.meetingPlaningDeliveries.filter((delivery) => delivery.id !== action.payload) }

        default:
            return state
    }
}

export default meetingPlanningReducer
